import React, { useEffect, useState, memo } from 'react';
import axios from 'axios';
import useTranslations from "../../hooks/useTranslations";
import { useParams, Link } from 'react-router-dom';
import Table from '../shared/table/Table'; 
import { FiEdit3, FiTrash2 } from 'react-icons/fi';
import "./RoleTable.css";
import useUserLanguage from "../../hooks/useUserLanguage"; 
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert"; // başta import



// 1) Durum Switch Bileşeni 
const TableCell = memo(({ roleId, initialStatus, fetchRoles }) => {
  const [isChecked, setIsChecked] = useState(initialStatus === 1);

  useEffect(() => {
    setIsChecked(initialStatus === 1);
  }, [initialStatus]);

  const toggleStatus = async () => {
    const newStatus = isChecked ? 0 : 1;
    setIsChecked(!isChecked);

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/roles/status/${roleId}`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${localStorage.getItem("admin_token")}` } }
      );
      fetchRoles(); // tabloyu yeniden yükle
    } catch (error) {
      console.error("Durum güncellenemedi:", error);
      setIsChecked(isChecked); // hata aldıysa geri al
    }
  };

  return (
    <div className="form-check form-switch text-end d-flex align-items-end justify-content-end">
      <input
        className="form-check-input custom-checkbox"
        type="checkbox"
        role="switch"
        checked={isChecked}
        onChange={toggleStatus}
        style={{ cursor: "pointer", width: "45px", height: "22px", transition: "0.3s ease-in-out" }}
      />
      <span
        className={`badge ms-2 ${isChecked ? "badge-success" : "badge-danger"}`}
        style={{
          padding: "6px 12px",
          borderRadius: "8px",
          fontSize: "14px",
          fontWeight: "bold",
          transition: "0.3s ease-in-out",
        }}
      />
    </div>
  );
});


// 2) RoleList Bileşeni

const RoleList = () => {
  const adminId = localStorage.getItem("admin_id");
  const language = useUserLanguage(); // Admin’in gerçek dilini al
  const { translations, setTranslations } = useTranslations(language);
  

  const [roles, setRoles] = useState([]);
  const [myPermissions, setMyPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Çeviri metni getiren fonksiyon
  const getText = (key, defaultValue = "") => {
    return translations && translations[key] ? translations[key] : defaultValue;
  };

  

  // Roller listesini API'den çek
  useEffect(() => {
    fetchRoles();
    fetchMyPermissions();
  }, []);

  const fetchRoles = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("admin_token");
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/roles`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRoles(response.data);
    } catch (error) {
      console.error(`${getText("LOG_ROLES_FETCH_ERROR")}`, error);
    }
    setLoading(false);
  };

  const handleSoftDelete = (id) => {
    confirmAlert({
      title: getText("SOFT_DELETE_CONFIRM_TITLE"),
      message: getText("SOFT_DELETE_CONFIRM_MSG"),
      buttons: [
        {
          label: getText("YES_SOFT_DELETE"),
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.put(
                `${process.env.REACT_APP_API_BASE_URL}/api/roles/delete/${id}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
              );
              toast.success(getText("DELETE_SUCCESS"));
              fetchRoles(); // tabloyu yenile
            } catch (error) {
              console.error("Soft delete hatası:", error);
              toast.error(getText("DELETE_ERROR"));
            }
          }
        },
        {
          label: getText("CANCEL"),
          onClick: () => toast.info(getText("SOFT_DELETE_CANCELLED")),
        }
      ],
    });
  };

  const fetchMyPermissions = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!resp.data || !Array.isArray(resp.data.permissions)) {
        console.error("API yanlış veri döndürdü:", resp.data);
        setMyPermissions([]);
      } else {
        setMyPermissions(resp.data.permissions);
      }
    } catch (error) {
      console.error(`${getText("LOG_PERMISSIONS_FETCH_ERROR")}`, error);
      setMyPermissions([]);
    }
  };

  // F) Tablonun kolonları
  const adminModulePerm = myPermissions.find((p) => p.module_key === "static_roles");
  const canEdit   = adminModulePerm?.edit_permission   || adminModulePerm?.full_access;
  const canDelete = adminModulePerm?.delete_permission || adminModulePerm?.full_access;

  const columns = [
    {
      accessorKey: 'id',
      header: () => getText("TABLE_ID_LABEL"),
      meta: { headerClassName: 'text-start', className: 'text-start' },
    },
    {
      accessorKey: 'role_name',
      header: () => getText("TABLE_TITLE_LABEL"),
      meta: { headerClassName: 'text-start', className: 'text-start' },
    },
    {
      accessorKey: 'created_at',
      header: () => (
        <div style={{ textAlign: 'end', width: '90%' }}>
          {getText("TABLE_DATE_LABEL")}
        </div>
      ),
      meta: { headerClassName: 'text-end', className: 'text-end date-column' },
      cell: (info) => {
        const rawDate = info.getValue();
        const formattedDate = new Date(rawDate).toLocaleDateString('en-GB');
        return (
          <div style={{ textAlign: 'end', width: '90%' }}>
            {formattedDate}
          </div>
        );
      },
    },
    {
      accessorKey: 'status',
      header: () => (
        <div style={{ textAlign: 'end', width: '100%' }}>
          {getText("TABLE_STATUS_LABEL")}
        </div>
      ),
      meta: { headerClassName: 'text-end', className: 'text-end status-column' },
      cell: (info) => (
        <div style={{ textAlign: 'end', width: '95%' }}>
          <TableCell
            roleId={info.row.original.id}
            initialStatus={info.row.original.status}
            fetchRoles={fetchRoles}
          />
        </div>
      ),
    },
    {
      accessorKey: 'actions',
      header: () => (
        <div style={{ textAlign: 'right', paddingRight: '50px' }}>
          {getText("TABLE_ACTIONS_LABEL")}
        </div>
      ),
      enableSorting: false,
      meta: { headerClassName: 'text-end', className: 'text-end' },
      cell: (info) => {
        const roleId = info.row.original.id;
        return (
          <div className="hstack gap-2 justify-content-end" style={{ paddingRight: '20px' }}>
            {canEdit && (
              <Link
                to={`/admin/roles/edit/${roleId}`}
                className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                title={getText("EDIT")}
              >
                <FiEdit3 />
              </Link>
            )}
            {canDelete && (
          <button
          onClick={e => {
            e.preventDefault(); 
            handleSoftDelete(roleId);
          }}
            className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
            title={getText("DELETE")}
          >
            <FiTrash2 />
          </button>
        )}
          </div>
        );
      },
    },
  ];

  //Loading kontrol
  if (loading) {
    return <p>{getText("LOADING_MSG")}</p>;
  }

  return (
    <Table
      data={roles}
      columns={columns}
      translations={translations}
      getText={getText}
    />
  );
};

export default RoleList;
